import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower } from '@btime/helpers'
import { compose, pathOr, curry } from 'ramda'
import React from 'react'

import { Text } from '../../../../components/presentation/Text'
import FlexGrid, { FlexColumn } from '../../../../components/structure/FlexGrid'
import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'
import DateText from '../../../../components/presentation/DateText'

const capitalizePath = curry((capFunc, fields, item) => compose(capFunc, pathOr('', fields))(item))

const UserCard = ({ item }) => {
  const placeName = capitalizePath(capitalizeAllIfLower, ['name'], item)
  const placeResume = capitalizePath(capitalizeAllIfLower, ['resume'], item)
  const placeLevelResume = pathOr('', ['placeLevelsResume'], item)
  const insertedAt = pathOr('', ['insertedAt'], item)

  return (
    <Panel smallPadding>
      <FlexGrid justify="flex-start" gutter={0.3}>
        <Text bold size="h3" color={COLORS.dark3}>
          {placeName}
        </Text>
      </FlexGrid>
      <Separator weight={3} line />

      <FlexGrid justify="flex-start" align="flex-start" gutter={0.3} direction="column">
        {placeLevelResume.map(item => (
          <Text key={item.name}>{item.name}</Text>
        ))}
      </FlexGrid>

      <FlexGrid justify="flex-start" align="flex-start" gutter={0.3}>
        <FlexColumn flex={1}>
          <DateText size="xsmall" bold align="right" color={COLORS.dark3} date={insertedAt} format="DD/MM/YYYY HH:mm" />
        </FlexColumn>
      </FlexGrid>
    </Panel>
  )
}

export default UserCard
